export const getJobStatusColor = (status: string) => {
    switch (status) {
        case "pending": return `gray`;
        case "completed": return "green"
        case "failed": return "red"
        default:
            return `gray`;
    }
};

export const getAlertStateColor = (status: string) => {
    switch (status) {
        case "OPEN": return `red`;
        case "ESCALATE": return "amber"
        case "NOTIFICATION": return "indigo"
        case "CLOSED": return "green"
        case "ACKNOWLEDGED":
        case "RECOVERED":
            return "yellow"
        default:
            return `gray`;
    }
};